
export const playback = {
  play: 'Reproduzir',
  pause: 'Pausar',
  mute: 'Silenciar',
  unmute: 'Ativar som',
  volume: 'Volume',
  fullscreen: 'Tela cheia',
  exitFullscreen: 'Sair da tela cheia',
  settings: 'Configurações',
  playbackSpeed: 'Velocidade de reprodução',
  normal: 'Normal',
  slow: 'Lento',
  fast: 'Rápido',
  repeat: 'Repetir',
  skipForward: 'Avançar',
  skipBackward: 'Retroceder',
  autoplay: 'Reprodução automática',
  quality: 'Qualidade',
  picture: 'Imagem',
  audio: 'Áudio',
  captions: 'Legendas',
  download: 'Baixar',
  share: 'Compartilhar'
};
